import { render, staticRenderFns } from "./CommitteeGroupEditList.vue?vue&type=template&id=20887442&scoped=true"
import script from "./CommitteeGroupEditList.vue?vue&type=script&lang=js"
export * from "./CommitteeGroupEditList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20887442",
  null
  
)

export default component.exports